import React, { useState } from "react";
import IssueList from "./IssueList";
import { Switch, Route, withRouter } from "react-router-dom";
import ViewIssue from "./ViewIssue";
import EditIssue from "./EditIssue";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as IssueActions from "../actions/IssueActions";
import { makeStyles } from '@material-ui/core/styles';
import ListIcon from '@material-ui/icons/List';
import AppsIcon from '@material-ui/icons/Apps';
import BuildIcon from '@material-ui/icons/Build';
import SearchIcon from '@material-ui/icons/Search';
import { SwipeableDrawer, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormGroup, FormControlLabel, Switch as UiSwitch } from "@material-ui/core";
import IssueGrid from "./IssueGrid";
import AlertDialog from "./AlertDialog";
import SearchFilter from "./SearchFilter";

const useStyles = makeStyles({
  nav: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    alignItems: "center",
    //paddingTop: "10px",
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingBottom: 0
  },
  navRight: {
    display: "flex",
    paddingRight: "10px",
    //margin: "10px",
    justifyContent: "space-between"
  },
  link: {
    color: "#3F51B5",
  },
  list: {
    width: 250,
  },
});

const AllIssuesPage = (props) => {
  const classes = useStyles();
  // view = true means grid view
  const [view, setView] = useState(true);
  //console.log(props);
  const [searchDrawer, setSearchDrawer] = useState(false);

  const [description, setDescription] = useState("");
  const [severity, setSeverity] = useState({
    Minor: false,
    Major: false,
    Critical: false
  });
  const [status, setStatus] = useState({
    Open: false,
    InProgress: false,
    Closed: false
  });

  const toggleDrawer = (open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setSearchDrawer(open);
  };

  const list = () => (
    <div
      className={classes.list}
      role="presentation"
      //onClick={toggleDrawer(false)}
      //onKeyDown={toggleDrawer(false)}
    >
      <div className={classes.nav}>
        <SearchFilter
          toggleDrawer={setSearchDrawer}
          description={description}
          setDescription={setDescription}
          status={status}
          setStatus={setStatus}
          severity={severity}
          setSeverity={setSeverity}
        />
      </div>
    </div>
  );

  const [state, setState] = useState({
    description: true,
    severity: true,
    status: true,
    createdDate: true,
    resolvedDate: true,
    lastUpdated: true,
    lastUpdatedBy: true,
    loggedBy: true,
  });

	const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [alertOpen, setAlertOpen] = useState(false);

  const [dialogTitle] = useState("Not Authenticated");
  const [dialogMessage] = useState("You are not logged in, head over to login page for performing this action?");

  return (
    <div>
      <Switch>
        <Route path="/issue-tracker/issues" exact>
          <div className={classes.nav}>
            <h2>All Issues</h2>
            <div className={classes.navRight}>
              <Button
                id="listViewButton"
                onClick={() => setView(false)}
                size="small" 
                color="primary"
                startIcon={<ListIcon />}
              >
                List View
              </Button>
              &nbsp;&nbsp;
              <Button
                id="gridViewButton"
                onClick={() => setView(true)}
                size="small" 
                color="primary"
                startIcon={<AppsIcon />}
              >
                Grid View
              </Button>
              &nbsp;&nbsp;
              <Button
                id="customizeButton"
                onClick={handleClickOpen}
                size="small" 
                color="primary"
                startIcon={<BuildIcon />}
              >
                Customize Fields
              </Button>
              <Button
                id="searchButton"
                onClick={toggleDrawer(true)}
                size="small" 
                color="primary"
                startIcon={<SearchIcon />}
              >
                Apply Filters
              </Button>
            </div>
          </div>

          {
            searchDrawer && <SwipeableDrawer
              open={searchDrawer}
              onClose={toggleDrawer(false)}
              onOpen={toggleDrawer(true)}
            >
              {list()}
            </SwipeableDrawer>
          }

          {props.issues && props.issues.length === 0 
            ? <p style={{padding: 10}}>No issues yet!</p> 
            : (view 
            ? <IssueGrid
                setAlertOpen={setAlertOpen} 
                issues={props.issues} 
                customization={state} 
              /> 
            : <IssueList setAlertOpen={setAlertOpen} issues={props.issues} customization={state} />)
          }

          {
          open && <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Customization Area</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Toggle the field you don't want to view...
              </DialogContentText>
              <FormGroup>
                {
                  Object.keys(state).map(k => (
                    <FormControlLabel
                      disabled={k === "description"}
                      key={k}
                      control={
                        <UiSwitch
                          checked={state[k]}
                          onChange={handleChange}
                          name={k}
                          color="primary"
                        />
                      }
                      label={k[0].toUpperCase() + k.replace(/([a-z0-9])([A-Z])/g, '$1 $2').substring(1)}
                    />
                  ))
                }
              </FormGroup>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Close
              </Button>
              <Button onClick={handleClose} color="primary">
                Save
              </Button>
            </DialogActions>
          </Dialog>
          }

          {alertOpen && <AlertDialog 
            alertOpen={alertOpen} 
            setAlertOpen={setAlertOpen}
            dialogTitle={dialogTitle}
            dialogMessage={dialogMessage}
          />}

        </Route>
        <Route path="/issue-tracker/issues/view/:id" exact>
          <ViewIssue issues={props.issues} />
        </Route>
        <Route path="/issue-tracker/issues/edit/:id" exact>
          <EditIssue />
        </Route>
      </Switch>
    </div>
  );
}

function mapStateToProps(state) {
  //console.log("[AllIssuesPage] ", state);
  return {
    issues: state.issues,
    users: state.users,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(IssueActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AllIssuesPage));
